var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDdxAudioAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.404297,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDF7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4142 15.9929C10.0217 15.6044 9.38856 15.6075 9 16C8.61144 16.3925 8.61461 17.0256 9.00709 17.4142L14.1217 22.1606C14.533 22.5677 15.2029 22.5418 15.5816 22.1042L23.7562 12.6542C24.1175 12.2366 24.0718 11.605 23.6542 11.2437C23.2365 10.8824 22.6049 10.9281 22.2436 11.3458L14.7687 19.9868L10.4142 15.9929Z",
    fill: "#3D8C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdxAudioAccept);
export default __webpack_public_path__ + "static/media/ddx-audio-accept.c6be1f9b3c0cffa49e8b64b9916ee75c.svg";
export { ForwardRef as ReactComponent };